var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html } from 'lit';
import { property } from 'lit/decorators.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import { BlocksElement } from '../../BlocksElement';
import styles from '../icon.styles';
/**
 * Image component
 * @csspart base- The component's base wrapper
 */
export class BlocksIconImage extends BlocksElement {
    static { this.styles = styles; }
    connectedCallback() {
        super.connectedCallback();
        this.classList.add('cat-icon');
    }
    render() {
        const componentClassName = this.componentClassNames('cat-c-icon', {
            'cat-c-icon--sm': this.size === 'sm',
            'cat-c-icon--lg': this.size === 'lg',
            'cat-c-icon--xl': this.size === 'xl',
            'cat-c-icon--content-strong': this.color === 'content-strong',
            'cat-c-icon--knockout': this.color === 'knockout',
            'cat-c-icon--knockout-brand': this.color === 'knockout-brand',
            'cat-c-icon--information': this.color === 'information',
            'cat-c-icon--success': this.color === 'success',
            'cat-c-icon--warning': this.color === 'warning',
            'cat-c-icon--error': this.color === 'error'
        });
        return html `
      <span part="base" class="${componentClassName}" role="presentation">
        <svg
          aria-hidden="${!this.iconTitle}"
          aria-label="${ifDefined(this.iconTitle)}"
          role="${this.iconTitle && 'img'}"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M21.3955 20.5845C21.3955 21.0323 21.0325 21.3953 20.5847 21.3953H3.41628C2.9685 21.3953 2.60551 21.0323 2.60551 20.5845V18.9934H21.3955V20.5845ZM21.3955 17.4934H8.96613L15.686 11.1992C15.6902 11.1971 15.6947 11.196 15.6994 11.196C15.7065 11.196 15.7134 11.1985 15.7189 11.2031C15.7328 11.2147 15.7472 11.2259 15.762 11.2365L21.3955 15.273V17.4934ZM2.60551 17.4934H6.77191L14.6873 10.0794C14.6979 10.0695 14.7088 10.0598 14.72 10.0505C14.995 9.82147 15.3415 9.69604 15.6994 9.69604C16.0467 9.69604 16.3833 9.81414 16.6542 10.0304L21.3955 13.4277V3.41603C21.3955 2.96826 21.0325 2.60526 20.5847 2.60526H3.41628C2.9685 2.60526 2.60551 2.96826 2.60551 3.41603V17.4934ZM1.10551 18.2358V3.41603C1.10551 2.13983 2.14007 1.10526 3.41628 1.10526H20.5847C21.8609 1.10526 22.8955 2.13983 22.8955 3.41603V20.5845C22.8955 21.8607 21.8609 22.8953 20.5847 22.8953H3.41628C2.14007 22.8953 1.10551 21.8607 1.10551 20.5845V18.2511L1.10547 18.2434L1.10551 18.2358ZM6.50732 8.09823C6.50732 7.21946 7.21971 6.50708 8.09848 6.50708C8.97725 6.50708 9.68963 7.21946 9.68963 8.09823C9.68963 8.977 8.97725 9.68939 8.09848 9.68939C7.21971 9.68939 6.50732 8.977 6.50732 8.09823ZM8.09848 5.00708C6.39128 5.00708 5.00732 6.39104 5.00732 8.09823C5.00732 9.80543 6.39128 11.1894 8.09848 11.1894C9.80568 11.1894 11.1896 9.80543 11.1896 8.09823C11.1896 6.39104 9.80568 5.00708 8.09848 5.00708Z"
          />
        </svg>
      </span>
    `;
    }
}
__decorate([
    property({ type: String })
], BlocksIconImage.prototype, "color", void 0);
__decorate([
    property({ type: String })
], BlocksIconImage.prototype, "iconTitle", void 0);
__decorate([
    property({ type: String })
], BlocksIconImage.prototype, "size", void 0);
if (customElements.get('cat-icon-image') === undefined) {
    customElements.define('cat-icon-image', BlocksIconImage);
}
